import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface XeroOutstandingPageProps {
  onBack: () => void;
}

export const XeroOutstandingPage: React.FC<XeroOutstandingPageProps> = ({ onBack }) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Button
          variant="text"
          size="small"
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
        >
          Back
        </Button>
        <Typography variant="h6" sx={{ ml: 1 }}>Outstanding invoices</Typography>
      </Box>

      <Alert severity="info" sx={{ maxWidth: 720 }}>
        Coming soon. The outstanding-invoices view requires a general
        unpaid-invoices query in <code>services/xero/core.py</code>, which
        isn't implemented yet — only the monthly-send flow currently fetches
        unpaid + unsent invoices for a specific contact list.
      </Alert>
    </Box>
  );
};
